const link = process.env.REACT_APP_SERVER_API_V2

const getEditContentUrl = () => `${link}/content/update`

export default getEditContentUrl

